import React from "react";
import { appColors, appRadius } from "../../utils/appTheme";

/**
 * Caja de icono cuadrada con esquinas redondeadas.
 * Base visual reutilizada por Tile, ListItem, BalanceCard, etc.
 */
const IconBox = ({
  icon,
  size = 40,
  bg = appColors.surface2,
  color = appColors.blue,
  radius = appRadius.iconBox,
  style,
}) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: size,
      height: size,
      minWidth: size,
      borderRadius: radius,
      background: bg,
      color,
      fontSize: Math.round(size * 0.46),
      ...style,
    }}
  >
    {icon}
  </span>
);

export default IconBox;
